// Module
var code = "<score-dist\n        item=\"row\"\n        score-dist=\"list.stats.hist\"\n        student-dist=\"list.stats.studentScores\"\n        view-config=\"viewConfig\"></score-dist>\n";
// Exports
module.exports = code;